import { usePortalData } from '../data/usePortalData';
import { useTicket } from '../data/useTicket';
import { useParams } from 'quartz-routing/react-router';
import { renderPropertyValue } from './formatCell';
export const useDetailsConfiguredTicketProperty = accessor => {
  var _ref;
  const {
    ticketId
  } = useParams();
  const {
    data: ticket
  } = useTicket(Number(ticketId));
  const {
    data: {
      configuredTicketProperties
    } = {}
  } = usePortalData();
  const configuredProperty = configuredTicketProperties === null || configuredTicketProperties === void 0 ? void 0 : configuredTicketProperties.find(({
    propertyName
  }) => propertyName === accessor);
  const {
    displayNameOverride: propertyDisplayName
  } = configuredProperty !== null && configuredProperty !== void 0 ? configuredProperty : {};
  const propertyValue = (_ref = ticket === null || ticket === void 0 ? void 0 : ticket[accessor]) !== null && _ref !== void 0 ? _ref : null;
  const formattedPropertyValue = configuredProperty ? renderPropertyValue(propertyValue, configuredProperty) : null;
  return {
    propertyDisplayName,
    propertyValue,
    formattedPropertyValue
  };
};